import navBootstrapStyles from './navigation-bootstrap-lite';
import headerfooterStyles from './navigation';
import NavHeader from './nav-header';
import FatFooter from './fat-footer';
import LegalFooter from './legal-footer';
import LiveChat from './live-chat';

document.addEventListener("DOMContentLoaded", function(event) {
  window.podsNavigation = new PodsNavigation;
});

class PodsNavigation {
  constructor(){
    const navHeader = new NavHeader;
    const legalFooter = new LegalFooter;
  }
}
